import React, { useCallback, useEffect, useState } from "react";

import { useForm, Controller } from "react-hook-form";

import {
  Box,
  Paper,
  Typography,
  Grid,
  TextField,
  Button,
  MenuItem,
  FormControlLabel,
  Switch,
  CircularProgress,
} from "@mui/material";

import { toast } from "react-toastify";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import moment from "moment";
import { useNavigate, useParams } from "react-router-dom";

import {
  createOffer,
  getOfferDetail,
  getOfferMetadata,
  getOffers,
  updateOffer,
} from "../../apis/cart/apis";

export default function CreateOfferScreen() {
  const navigate = useNavigate();
  const { id } = useParams();
  const [offers, setOffers] = useState([]);
  const isEdit = Boolean(id);
  console.log({
    id,
    isEdit,
  });

  const [loading, setLoading] = useState(false);

  const [metadata, setMetadata] = useState({
    offer_types: [],
    benefit_types: [],
    condition_types: [],
    custom_benefits: [],
    ranges: [],
  });

  const {
    control,
    setValue,
    watch,
    reset,
    // getValues,
    setError,
    clearErrors,
    handleSubmit: rhfHandleSubmit,
    formState: { isValid },
  } = useForm({
    mode: "onChange",
    defaultValues: {
      name: "",
      description: "",

      offer_type: "",

      range_id: "",

      benefit_type: "",
      benefit_value: "",

      max_affected_items: "",

      custom_benefit_id: "",

      condition_type: "",
      condition_value: "",

      start_datetime: moment().toISOString(),
      end_datetime: "",

      max_basket_applications: "",
      max_user_applications: "",
      max_global_applications: "",

      max_discount: "",

      priority: 0,

      exclusive: true,
    },
  });
  const customBenefitId = watch("custom_benefit_id");
  const offerName = watch("name");
  const offerStart = watch("start_datetime");
  const offerEnd = watch("end_datetime");
  const fetchOffers = useCallback(async () => {
    try {
      const response = await getOffers();
      setOffers(response.data.results);
      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  }, []);
  const fetchMetadata = useCallback(async () => {
    try {
      const response = await getOfferMetadata();

      setMetadata(response.data);
      if (response.data.offer_types?.length > 0) {
        setValue("offer_type", response.data.offer_types[1].value);
      }
      if (response.data.ranges?.length > 0) {
        setValue("range_id", response.data.ranges[0].id);
      }
    } catch (error) {
      console.log(error);
    }
  }, [setValue]);

  useEffect(() => {
    fetchMetadata();
    fetchOffers();
  }, [fetchMetadata, fetchOffers]);

  useEffect(() => {
    if (!isEdit) {return;}

    const fetchOffer = async () => {
      try {
        const response = await getOfferDetail(id);

        const offer = response.data;

        reset({
          name: offer.name,
          description: offer.description,
          offer_type: offer.offer_type,
          range_id: offer.range_id,
          benefit_type: offer.benefit_type,
          benefit_value: offer.benefit_value,
          max_affected_items: offer.max_affected_items,
          condition_type: offer.condition_type,
          condition_value: offer.condition_value,
          priority: offer.priority,
          exclusive: offer.exclusive,
          start_datetime: offer.start_datetime || "",
          end_datetime: offer.end_datetime || "",
          max_basket_applications: offer.max_basket_applications,
          max_user_applications: offer.max_user_applications,
          max_global_applications: offer.max_global_applications,
          max_discount: offer.max_discount,
        });
      } catch (error) {
        console.log(error);
      }
    };

    fetchOffer();
  }, [id, isEdit, reset]);

  useEffect(() => {
    // Offer name validation
    if (!offerName?.trim()) {
      clearErrors("name");
    } else {
      const exists = offers.some(
        (offer) =>
          offer.name.trim().toLowerCase() === offerName.trim().toLowerCase() &&
          (!isEdit || offer.id !== Number(id)),
      );

      if (exists) {
        setError("name", {
          type: "manual",
          message: "An offer with this name already exists.",
        });
      } else {
        clearErrors("name");
      }
    }

    // Date validation
    if (!offerStart || !offerEnd) {
      clearErrors("end_datetime");
    } else if (moment(offerEnd).isBefore(moment(offerStart))) {
      setError("end_datetime", {
        type: "manual",
        message: "End date must be after the start date.",
      });
    } else {
      clearErrors("end_datetime");
    }
  }, [
    offerName,
    offerStart,
    offerEnd,
    offers,
    isEdit,
    id,
    setError,
    clearErrors,
  ]);
  const onSubmit = async (data) => {
    try {
      const customBenefit = data.custom_benefit_id;

      if (customBenefit) {
        if (data.benefit_type || data.benefit_value) {
          setError("custom_benefit_id", {
            type: "manual",
            message:
              "Please select either a Custom Incentive OR Benefit Type/Value",
          });

          return;
        }

        clearErrors(["benefit_type", "benefit_value", "range_id"]);
      }

      setLoading(true);

      const payload = {
        ...data,
        end_datetime: data.end_datetime
          ? new Date(data.end_datetime).toISOString()
          : null,
        benefit_value: Number(data.benefit_value),

        custom_benefit_id: data.custom_benefit_id || null,

        condition_value: Number(data.condition_value),

        max_discount: data.max_discount ? Number(data.max_discount) : null,

        max_basket_applications: data.max_basket_applications || null,

        max_user_applications: data.max_user_applications || null,

        max_global_applications: data.max_global_applications || null,

        max_affected_items: data.max_affected_items || null,
      };

      if (isEdit) {
        await updateOffer(id, payload);

        toast.success("Offer updated successfully");
      } else {
        await createOffer(payload);

        toast.success("Offer created successfully");
      }
      navigate("/w86zjruk6q/offers");
    } catch (error) {
      if (error?.response?.data?.name) {
        setError("name", {
          type: "server",
          message: error.response.data.name[0],
        });
        return;
      }

      toast.error("Failed to create offer");
    } finally {
      setLoading(false);
    }
  };
  return (
    <Box p={3}>
      <Paper sx={{ p: 3 }}>
        <Typography variant="h4" gutterBottom>
          {isEdit ? "Update Offer" : "Create Offer"}
        </Typography>

        <Grid container spacing={2} sx={{ mt: 1 }}>
          {/* Offer Details */}

          <Grid item xs={12}>
            <Controller
              name="name"
              control={control}
              rules={{
                required: "Offer Name is required",
                validate: (value) => {
                  const exists = offers.some(
                    (offer) =>
                      offer.name.trim().toLowerCase() ===
                      value.trim().toLowerCase() &&
                      (!isEdit || offer.id !== Number(id)),
                  );

                  return exists
                    ? "An offer with this name already exists."
                    : true;
                },
              }}
              render={({ field, fieldState }) => (
                <TextField
                  {...field}
                  fullWidth
                  required
                  label="Offer Name"
                  onChange={(e) => {
                    console.log("typing:", e.target.value);
                    field.onChange(e);
                  }}
                  error={!!fieldState.error}
                  helperText={fieldState.error?.message}
                //   disabled={isEdit}
                />
              )}
            />
          </Grid>

          <Grid item xs={12}>
            <Controller
              name="description"
              control={control}
              render={({ field }) => (
                <TextField
                  {...field}
                  fullWidth
                  multiline
                  rows={4}
                  label="Description"
                //   disabled={isEdit}
                />
              )}
            />
          </Grid>

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="offer_type"
                control={control}
                disabled={isEdit}
                rules={{
                  required: "Offer Type is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    label="Offer Type"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    disabled={isEdit}
                  >
                    <MenuItem value="">Select Offer Type</MenuItem>

                    {metadata.offer_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="priority"
                control={control}
                rules={{
                  required: "Priority is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="number"
                    label="Priority"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    disabled={isEdit}
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {/* Benefit */}

          {!isEdit && (
            <Grid item xs={12}>
              <Controller
                name="range_id"
                control={control}
                rules={{
                  required: !customBenefitId ? "Range is required" : false,
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    label="Range"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                    disabled={isEdit}
                  >
                    <MenuItem value="">Select Range</MenuItem>

                    {metadata.ranges.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.name}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="benefit_type"
                control={control}
                disabled={isEdit}
                rules={{
                  required: !customBenefitId
                    ? "Benefit Type is required"
                    : false,
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    label="Benefit Type"
                    required
                    disabled={isEdit}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">Select Benefit Type</MenuItem>

                    {metadata.benefit_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="benefit_value"
                control={control}
                disabled={isEdit}
                rules={{
                  required: !customBenefitId
                    ? "Benefit Value is required"
                    : false,
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Benefit Value"
                    required
                    inputProps={{
                      min: 0,
                    }}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          )}
          {!isEdit && (
            <Grid item xs={12}>
              <Controller
                name="max_affected_items"
                control={control}
                disabled={isEdit}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    type="number"
                    label="Max Affected Items"
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12}>
              <Typography variant="body2" sx={{ mb: 1 }}>
                Or choose a predefined incentive
              </Typography>

              <Controller
                name="custom_benefit_id"
                control={control}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    disabled={isEdit}
                    label="Custom Incentive"
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">None</MenuItem>

                    {metadata.custom_benefits.map((item) => (
                      <MenuItem key={item.id} value={item.id}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}
          {/* Condition */}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="condition_type"
                control={control}
                rules={{
                  required: "Condition Type is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    value={field.value || ""}
                    select
                    fullWidth
                    disabled={isEdit}
                    label="Condition Type"
                    required
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  >
                    <MenuItem value="">Select Condition Type</MenuItem>

                    {metadata.condition_types.map((item) => (
                      <MenuItem key={item.value} value={item.value}>
                        {item.label}
                      </MenuItem>
                    ))}
                  </TextField>
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={6}>
              <Controller
                name="condition_value"
                control={control}
                rules={{
                  required: "Condition Value is required",
                }}
                render={({ field, fieldState }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Condition Value"
                    required
                    inputProps={{
                      min: 0,
                    }}
                    error={!!fieldState.error}
                    helperText={fieldState.error?.message}
                  />
                )}
              />
            </Grid>
          )}

          {/* Restrictions */}

          <Grid item xs={12}>
            <LocalizationProvider dateAdapter={AdapterMoment}>
              <Grid container spacing={2}>
                <Grid item xs={12} md={6}>
                  <Controller
                    name="start_datetime"
                    control={control}
                    rules={{
                      required: "Start Date is required",
                    }}
                    render={({ field, fieldState }) => (
                      <DateTimePicker
                        label="Start Date"
                        value={field.value ? moment(field.value) : null}
                        onChange={(value) =>
                          field.onChange(value ? value.toISOString() : "")
                        }
                        disabled={isEdit}
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <Controller
                    name="end_datetime"
                    control={control}
                    rules={{
                      required: "End Date is required",
                      validate: (value) => {
                        const start = watch("start_datetime");

                        if (
                          start &&
                          value &&
                          moment(value).isBefore(moment(start))
                        ) {
                          return "End date must be after the start date.";
                        }

                        return true;
                      },
                    }}
                    render={({ field, fieldState }) => (
                      <DateTimePicker
                        label="End Date"
                        value={field.value ? moment(field.value) : null}
                        onChange={(value) =>
                          field.onChange(value ? value.toISOString() : "")
                        }
                        minDateTime={
                          offerStart ? moment(offerStart) : undefined
                        }
                        renderInput={(params) => (
                          <TextField
                            required
                            {...params}
                            fullWidth
                            error={!!fieldState.error}
                            helperText={fieldState.error?.message}
                            inputProps={{
                              ...params.inputProps,
                              readOnly: true,
                            }}
                          />
                        )}
                      />
                    )}
                  />
                </Grid>
              </Grid>
            </LocalizationProvider>
          </Grid>

          {!isEdit && (
            <Grid item xs={12} md={4}>
              <Controller
                name="max_discount"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Max Discount"
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12} md={4}>
              <Controller
                name="max_basket_applications"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Max Cart Applications"
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}
          {!isEdit && (
            <Grid item xs={12} md={4}>
              <Controller
                name="max_user_applications"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Max User Applications"
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12}>
              <Controller
                name="max_global_applications"
                control={control}
                render={({ field }) => (
                  <TextField
                    {...field}
                    fullWidth
                    disabled={isEdit}
                    type="number"
                    label="Max Global Applications"
                    inputProps={{
                      min: 0,
                    }}
                  />
                )}
              />
            </Grid>
          )}

          {!isEdit && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Controller
                    name="exclusive"
                    control={control}
                    render={({ field }) => (
                      <Switch
                        checked={field.value}
                        disabled={isEdit}
                        onChange={(e) => field.onChange(e.target.checked)}
                      />
                    )}
                  />
                }
                label="Exclusive Offer"
              />
            </Grid>
          )}

          <Grid item xs={12}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                mt: 2,
              }}
            >
              <Button
                variant="contained"
                disabled={loading || !isValid}
                onClick={rhfHandleSubmit(onSubmit)}
              >
                {loading ? (
                  <CircularProgress size={20} />
                ) : isEdit ? (
                  "Update Offer"
                ) : (
                  "Create Offer"
                )}
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
}
